{
  "home": "Asukassivut",
  "contract": "Sopimus",
  "defectNotice": "Vikailmoitus",
  "confirmContractTermination": "Vahvista irtisanominen",
  "messages": "Viestit",
  "feedback": "Palaute",
  "paymentHistory": "Maksuhistoria",
  "paymentInformation": "Laskut ja maksutiedot",
  "contractModification": "Sopimusmuutokset",
  "documents": "Asiakirjat",
  "userInfo": "Käyttäjätiedot",
  "notFound": "Sivua ei löydy",
  "bulletin": "Tiedote",
  "building": "Kiinteistön tiedot",
  "bulletinBoard": "Kaikki tiedotteet",
  "contactInformation": "Yhteystiedot",
  "parking": "Pysäköintipaikat",
  "gymBooking": "Kuntosalivuorot",
  "gymReservations": "Kuntosalivaraukset",
  "laundryReservations": "Pesulavaraukset",
  "saunaReservations": "Saunavuorot",
  "commonAreaReservations": "Kokoontumistilat",
  "storages": "Varastot"
}
